module.exports = __webpack_public_path__ + "static/modal-bg.5f54e0d9.png";